import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { cn } from "@/utils/cn";
import { cva } from "class-variance-authority";

const itemVariants = cva("relative flex", {
    variants: {
        variant: {
            success: "text-emerald-25",
            danger: "text-red-500",
        },
    },
    defaultVariants: {
        variant: "danger",
    },
});

const iconClass = cn("absolute top-1/2 -left-8 size-5 -translate-y-1/2");

const PolicyItem = ({ variant, children }) => {
    const Icon = variant === "success" ? CheckIcon : XMarkIcon;

    return (
        <div className={cn(itemVariants({ variant }))}>
            <Icon className={iconClass} />
            {children}
        </div>
    );
};

export const PasswordPolicy = ({ password = "" }) => {
    const casePolicy = /[a-z]/.test(password) && /[A-Z]/.test(password);

    const numberPolicy = /\d/.test(password) && /[^a-zA-Z0-9]/.test(password);

    const lengthPolicy = password.length >= 12;

    return (
        <div>
            <span className="font-medium">Create a password that:</span>
            <div className="relative mt-2 ml-8 list-none">
                <PolicyItem variant={casePolicy ? "success" : "danger"}>
                    includes both upper and lower case characters
                </PolicyItem>
                <PolicyItem variant={numberPolicy ? "success" : "danger"}>
                    includes at least one number and one symbol
                </PolicyItem>
                <PolicyItem variant={lengthPolicy ? "success" : "danger"}>
                    contains at least 12 characters
                </PolicyItem>
            </div>
        </div>
    );
};
